	components: {
		Content,
	},
	components: {
		Content,
	},
	components: {
		Content,
	},
	components: {
		Content,
	},<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/"> Home </router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <a class="decoration"> Maintainence Management </a>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Upload File
      </h6>

      <div style="padding-bottom: 100px;" class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="SaveProduct">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Pdf/ Excel</label>
                    <input type="file" @change="handleFileUpload" class="form-control bdr-rad" />
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Date</label>
                    <input type="text" v-model="alldata.date" class="form-control bdr-rad" />
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="custom-label" style="font-size: small;">Number</label>
                    <input type="text" v-model="alldata.number" class="form-control bdr-rad" />
                  </div>
                </div>
              </div>

              <div class="navbar">
                <div class="d-flex"></div>
                <div class="d-flex">
                  <button type="submit" class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad">
                    Upload
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- aœ… Popup Modal -->
<!-- aœ… Popup Modal -->
<div v-if="showPopup" class="popup-overlay">
  <div class="popup-card">
    <!-- Fixed Header -->
    <div class="popup-header">
      <h5>Crop area to extract text</h5>
    </div>

    <!-- Scrollable Content -->
    <div class="popup-body">
      <!-- Show OCR editable box if result exists -->
      

      <!-- PDF Canvas -->
      <canvas v-show="!ocrText"
        ref="pdfCanvas"
        @mousedown="startSelection"
        @mousemove="drawSelection"
        @mouseup="endSelection"></canvas>
    </div>

    <!-- Fixed Footer -->
   <div class="popup-footer ">
  <!-- OCR Result input (left side) -->
  <div v-if="ocrText" class="mb-1">
    <label class="mb-1">OCR Result (editable):</label>
    <input type="text" v-model="ocrText" class="form-control" />
  </div>

  <!-- Buttons (right side) -->
  <div class="">
    <button class="btn btn-sm btn-secondary mr-1" @click="closePopup">Cancel</button>
    <button v-if="!ocrText" class="btn btn-sm btn-primary" @click="runOcr">Save</button>
    <button v-else class="btn btn-sm btn-success " @click="confirmOcr">Confirm</button>
  </div>
</div>

  </div>
</div>



    <content-footer></content-footer>
  </div>
</template>

<script>
import Content from '@/layout/Content.vue'

export default {
  components: { Content },
  data() {
    return {
      file: null,
      alldata: {},
      showPopup: false,
      pdfPage: null,
      selection: null,
      isSelecting: false,
      ocrText: "",
    };
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },

    async SaveProduct() {
      if (!this.file) {
        alert("Please select a file first.");
        return;
      }

      if (this.file.type.includes("pdf")) {
        this.showPopup = true;
        await this.renderPDF(this.file);
      } else {
        alert("Only PDF supported for crop OCR here.");
      }
    },

    async renderPDF(file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const typedarray = new Uint8Array(e.target.result);
        const pdf = await window.pdfjsLib.getDocument({ data: typedarray }).promise;

        // clear old canvases
        const popupCard = this.$el.querySelector(".popup-card");
        popupCard.querySelectorAll("canvas").forEach(c => c.remove());

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale: 1.5 });

          const canvas = document.createElement("canvas");
          canvas.width = Math.round(viewport.width);
          canvas.height = Math.round(viewport.height);
          canvas.style.marginBottom = "10px";
          canvas.style.border = "1px solid #ccc";
          canvas.dataset.page = pageNum;

          const ctx = canvas.getContext("2d");

          const bufferCanvas = document.createElement("canvas");
          bufferCanvas.width = canvas.width;
          bufferCanvas.height = canvas.height;
          const bufferCtx = bufferCanvas.getContext("2d");

          await page.render({ canvasContext: bufferCtx, viewport }).promise;

          // draw into visible canvas
          ctx.drawImage(bufferCanvas, 0, 0);

          // attach events for selection (pass bufferCanvas for redraw)
          canvas.addEventListener("mousedown", (ev) => this.startSelection(ev, canvas, bufferCanvas));
          canvas.addEventListener("mousemove", (ev) => this.drawSelection(ev, canvas, bufferCanvas));
          canvas.addEventListener("mouseup", (ev) => this.endSelection(ev, canvas, bufferCanvas));
          canvas.addEventListener("mouseleave", (ev) => {
            // end selection if mouse leaves
            if (this.isSelecting) this.endSelection(ev, canvas, bufferCanvas);
          });

          const popupBody = popupCard.querySelector(".popup-body");
          popupBody.appendChild(canvas);
        }
      };
      reader.readAsArrayBuffer(file);
    },

    // --- Selection helpers ---
    startSelection(e, canvas, bufferCanvas) {
      this.isSelecting = true;
      const rect = canvas.getBoundingClientRect();
      this.selection = {
        canvas,
        bufferCanvas,
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
        w: 0,
        h: 0,
      };
    },

    drawSelection(e, canvas, bufferCanvas) {
      if (!this.isSelecting || !this.selection) return;
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      this.selection.w = x - this.selection.x;
      this.selection.h = y - this.selection.y;

      // redraw from buffer
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(bufferCanvas, 0, 0);

      // draw selection rectangle
      ctx.save();
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.setLineDash([6]);
      // draw rect with support for negative w/h (dragging left/up)
      const sx = this.selection.w < 0 ? this.selection.x + this.selection.w : this.selection.x;
      const sy = this.selection.h < 0 ? this.selection.y + this.selection.h : this.selection.y;
      const sw = Math.abs(this.selection.w);
      const sh = Math.abs(this.selection.h);
      ctx.strokeRect(sx, sy, sw, sh);
      ctx.restore();
    },

    endSelection(e, canvas, bufferCanvas) {
      if (!this.selection) return;
      this.isSelecting = false;

      // normalize selection coordinates (so width/height are positive)
      let { x, y, w, h } = this.selection;
      const sx = w < 0 ? x + w : x;
      const sy = h < 0 ? y + h : y;
      const sw = Math.abs(w);
      const sh = Math.abs(h);

      // small area guard
      if (sw < 5 || sh < 5) {
        this.selection = null;
        // redraw full page without box
        const ctx = canvas.getContext("2d");
        ctx.drawImage(bufferCanvas, 0, 0);
        return;
      }

      this.selection = { canvas, bufferCanvas, x: sx, y: sy, w: sw, h: sh };

      // final draw of rectangle
      const ctx = canvas.getContext("2d");
      ctx.drawImage(bufferCanvas, 0, 0);
      ctx.save();
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.setLineDash([6]);
      ctx.strokeRect(sx, sy, sw, sh);
      ctx.restore();
    },

    // --- OCR pipeline ---
    async runOcr() {
      if (!this.selection) {
        alert("Please select an area first.");
        return;
      }

      const { canvas, x, y, w, h } = this.selection;

      // create crop canvas with normalized width/height
      const cropCanvas = document.createElement("canvas");

      // If the selection is very small, upscale more aggressively.
      const scaleFactor = 2.5; // try 2.5 or 3.0 if original PDF is low-res; tweak to taste
      cropCanvas.width = Math.max(1, Math.round(Math.abs(w) * scaleFactor));
      cropCanvas.height = Math.max(1, Math.round(Math.abs(h) * scaleFactor));
      const cropCtx = cropCanvas.getContext("2d");

      // draw scaled crop from original canvas
      // use drawImage(source, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
      cropCtx.drawImage(canvas, x, y, w, h, 0, 0, cropCanvas.width, cropCanvas.height);

      // preprocess: grayscale -> contrast -> sharpen -> threshold
      this._preprocessCanvas(cropCanvas);

      // Tesseract options tuned for short single-line dates
      // psm 7 (single text line) frequently helps date extraction
      // whitelist digits, letters and separators (space, . / -)
      const tessOptions = {
        tessedit_pageseg_mode: "7", // single text line
        tessedit_char_whitelist: "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.-/ ",
      };

      try {
        // Use Tesseract.recognize with explicit config string if available
        // Some builds accept an options object; otherwise use `config` string
        const configStr = Object.entries(tessOptions)
          .map(([k, v]) => `-c ${k}=${v}`)
          .join(" ");

        // pass psm via second param `options` where supported:
        const result = await window.Tesseract.recognize(cropCanvas, "eng", {
          logger: m => { /* optional: console.log(m) */ },
          // pass config string to Tesseract if supported:
          tessedit_pageseg_mode: "7",
          // fallback config string:
          config: `--psm 7 -c tessedit_char_whitelist=${tessOptions.tessedit_char_whitelist}`
        });

       this.ocrText = ((result && result.data && result.data.text) || "").trim();
        if (!this.ocrText) {
          // If empty, try a fallback OCR with psm 6 (single block)
          const fallback = await window.Tesseract.recognize(cropCanvas, "eng", {
            config: "--psm 6 -c tessedit_char_whitelist=0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.-/ "
          });
        this.ocrText = ((fallback && fallback.data && fallback.data.text) || "").trim();
        }
      } catch (err) {
        console.error("OCR error", err);
        alert("OCR failed. See console for details.");
      }
    },

    confirmOcr() {
      this.alldata.number = this.ocrText;
      this.showPopup = false;
      this.ocrText = "";
      this.selection = null;
    },

    closePopup() {
      this.showPopup = false;
      this.selection = null;
      this.ocrText = "";
    },

    // --- Image processing helpers (simple, pure JS) ---
    _preprocessCanvas(canvas) {
      const ctx = canvas.getContext("2d");
      const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imgData.data;

      // 1) convert to grayscale & compute luminances
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i], g = data[i+1], b = data[i+2];
        // luminosity formula (perceived)
        const lum = 0.2126*r + 0.7152*g + 0.0722*b;
        data[i] = data[i+1] = data[i+2] = lum;
      }

      // 2) increase contrast - simple linear contrast adjustment
      // compute mean luminance
      let sum = 0;
      for (let i = 0; i < data.length; i += 4) sum += data[i];
      const mean = sum / (data.length / 4);
      const contrastFactor = 1.6; // >1 raises contrast; tweak if necessary
      for (let i = 0; i < data.length; i += 4) {
        let v = data[i];
        v = (v - mean) * contrastFactor + mean;
        v = Math.max(0, Math.min(255, v));
        data[i] = data[i+1] = data[i+2] = v;
      }

      // 3) optional: simple sharpen convolution
      // We'll apply a 3x3 unsharp-like kernel (add laplacian)
      const width = canvas.width, height = canvas.height;
      const copy = new Uint8ClampedArray(data); // copy for convolution source
      const kernel = [
         0, -1,  0,
        -1,  5, -1,
         0, -1,  0
      ];
      for (let y = 1; y < height-1; y++) {
        for (let x = 1; x < width-1; x++) {
          let acc = 0;
          for (let ky = -1; ky <= 1; ky++) {
            for (let kx = -1; kx <= 1; kx++) {
              const srcX = x + kx;
              const srcY = y + ky;
              const srcIdx = (srcY * width + srcX) * 4;
              const kval = kernel[(ky+1)*3 + (kx+1)];
              acc += copy[srcIdx] * kval;
            }
          }
          const idx = (y * width + x) * 4;
          const v = Math.max(0, Math.min(255, acc));
          data[idx] = data[idx+1] = data[idx+2] = v;
        }
      }

      // 4) simple global adaptive-ish threshold:
      // compute histogram and pick threshold around mean
      let hist = new Array(256).fill(0);
      for (let i = 0; i < data.length; i += 4) hist[data[i]]++;
      // mean gray again:
      let total = 0; let sumGray = 0;
      for (let i=0;i<256;i++){ total += hist[i]; sumGray += hist[i]*i; }
      const globalMean = sumGray/total;
      // choose threshold a bit below mean to keep dark text
      let thresh = Math.max(60, Math.min(200, Math.round(globalMean * 0.9)));

      for (let i = 0; i < data.length; i += 4) {
        const v = data[i] < thresh ? 0 : 255;
        data[i] = data[i+1] = data[i+2] = v;
      }

      ctx.putImageData(imgData, 0, 0);
    }
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-card {
  background: #fff;
  width: 80%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
}
canvas {
  border: 1px solid #ccc;
  cursor: crosshair;
}

.popup-header {
  background: #f8f9fa;
  border-bottom: 1px solid #ddd;
  padding: 10px;
}


/* Scrollable middle section */
.popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

/* Fixed footer */
.popup-footer {
  background: #fff;
  border-top: 1px solid #ddd;
  padding: 10px;
  width: 500px;
  align-items: center;
  justify-content: space-between; /* OCR input left, buttons right */
}
.ocr-box {
  flex: 1;
  margin-right: 15px;
}
</style>
